import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'lang-switcher',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    button: {
      textTransform: 'uppercase',
      '& svg': {
        marginLeft: theme.spacing(1),
      },
    },
    dropdown: {},
    dropdownItem: {
      'li&': {
        textTransform: 'uppercase',
        textAlign: 'center',
        ...theme.typography.body3,
      },
    },
  }),
  options
);

export default useStyles;
